import { render, staticRenderFns } from "./FieldRecordSystem.vue?vue&type=template&id=3f8e5f14&scoped=true&lang=html&"
import script from "./FieldRecordSystem.vue?vue&type=script&lang=js&"
export * from "./FieldRecordSystem.vue?vue&type=script&lang=js&"
import style0 from "./FieldRecordSystem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FieldRecordSystem.vue?vue&type=style&index=1&id=3f8e5f14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8e5f14",
  null
  
)

export default component.exports